var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetoxicity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.linesandangles_een{fill:#2E642C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linesandangles_een",
    d: "M28,17v-2H17v-2.052C23.289,12.418,25,6.96,25,4V3h-1c-4.416,0-6.814,2.266-8,4.729 C14.814,5.266,12.416,3,8,3H7v1c0,2.96,1.711,8.418,8,8.948V15H4v2h11v3.285c-1.474,0.78-3,3.009-3,4.715c0,2.206,1.794,4,4,4 s4-1.794,4-4c0-1.706-1.526-3.935-3-4.715V17H28z M22.898,5.062c-0.291,1.821-1.42,5.367-5.797,5.877 C17.393,9.118,18.521,5.572,22.898,5.062z M9.101,5.062c4.377,0.51,5.507,4.056,5.798,5.877C10.521,10.428,9.392,6.881,9.101,5.062z  M16,27c-1.103,0-2-0.897-2-2c0-1.124,1.484-2.873,1.953-3.004C16.516,22.127,18,23.876,18,25C18,26.103,17.103,27,16,27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetoxicity);
export default __webpack_public_path__ + "static/media/detoxicity.6c1f6b17d027a211619dba939118c111.svg";
export { ForwardRef as ReactComponent };